<template>
    <el-table :data="fileData" border>
        <el-table-column label="序号" type="index" :index="generateIndex" width="120" align="center"></el-table-column>
        <el-table-column prop="file_name" :label="labelName" fit align="center"></el-table-column>
        <el-table-column prop="upload_time" label="上传时间" fit align="center"></el-table-column>
        <el-table-column label="操作" fit align="center">
            <template slot-scope="scope">
                <download text="下载" :download-id="scope.row.id" :download-type="scope.row.quest_type"/>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    import download from "../public/file/download";

    export default {
        name: "taskDetailTranslatorFileListItem",
        components:{download},
        props:{
            fileData:{type:Array, required:true},
            labelName:{type:String, required: true}
        },
        methods:{
            generateIndex(index){
                return index + 1
            }
        }
    }
</script>

<style scoped>

</style>